import sileo from 'sileo';

const ImageGallery = new sileo.Model('hqzen', 'image-gallery');

const state = {};

const getters = {};

const mutations = {};

const actions = {
    fetchImageGallery(context, filters) {
        return ImageGallery.objects.filter(filters);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
